/**
 * Labstep
 */

import type { ParamsHOCChildrenProps } from 'labstep-web/hoc/Params/types';
import type { TreeEntity } from 'labstep-web/models';
import type { PostFilterResourceLocation } from 'labstep-web/services/postFilter/filters/resourceLocation';
import type { TreeContainerProps } from './types';

export const sortByName = (entities: TreeEntity[]): TreeEntity[] =>
  entities.sort((a, b) =>
    a.name ? a.name.localeCompare(b.name) : 1,
  );

/**
 * Get a function to set the active tree entity
 * Based on post filter
 * @param filter Post filter
 * @param addPostFilter Add post filter function
 * @param setParams Set params function
 * @returns Function to set active tree entity
 */
export const getSetActiveTreeEntity =
  (
    setParams: ParamsHOCChildrenProps['setParams'],
    addPostFilter: ParamsHOCChildrenProps['addPostFilter'],
    filter?: typeof PostFilterResourceLocation,
  ) =>
  (
    entityName: TreeContainerProps['entityName'],
    entity?: TreeEntity,
    unsorted?: TreeContainerProps['unsorted'],
  ): void => {
    if (filter) {
      addPostFilter(filter.getNode([entity?.guid]), true);
    } else {
      setParams({
        [`${entityName}_id`]: entity?.guid,
        ...(unsorted && {
          [unsorted.param]: undefined,
        }),
      });
    }
  };

/**
 * Check if a tree entity is active
 * @param searchParams Search params
 * @param entity Entity
 * @param filter Post filter
 * @returns True if active
 */
export const isActiveTreeEntity = (
  searchParams: Record<string, unknown>,
  entity: TreeEntity,
  filter?: typeof PostFilterResourceLocation,
): boolean =>
  filter
    ? !!filter.getNodeInParams(searchParams, [entity.guid])
    : searchParams[`${entity.entityName}_id`] === entity.guid;
